export const Options = {
    body: {
        key: [],
        tgap: [],
        warn: [],
        code: [],
        name: []
    },
    list: {
        key: model => model.key
    }
};
